import { ErrorLoc } from '../data/errors.locs';

export const errorLocMap: Record<string, ErrorLoc> = {
	ba5e95f44eff426baed79f1230c977a8: 'CMSystemErrorDefault',
	'86e45e9681494ad48dcd6732556063c7': 'SPMergeUniqueLoser',
	'637a4c5fcc214fabacc94d28e2bfcf3a': 'SPMergeUniqueLoser',
};
